import { render, staticRenderFns } from "./ContactDataManagement.vue?vue&type=template&id=2423a8e9&scoped=true&"
import script from "./ContactDataManagement.vue?vue&type=script&lang=js&"
export * from "./ContactDataManagement.vue?vue&type=script&lang=js&"
import style0 from "./ContactDataManagement.vue?vue&type=style&index=0&id=2423a8e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423a8e9",
  null
  
)

export default component.exports